<template>
  <div class="breadcrumb">
    <span class="home" @click="jump">首页</span>
    <span class="home"> &nbsp;&nbsp;/&nbsp;&nbsp;</span>
    <span class="current-route">{{ pageName }}</span>
  </div>
</template>
<script>
export default{
  props: {
    pageName: {
      type: String,
      default: ''
    }
  },
  methods: {
    jump () {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss" scoped>
.breadcrumb {
  height: 44px;
  line-height: 44px;
  padding-left: 20px;
  background: #fff;
  font-size: 18px;
  font-weight: 600;
  .home {
    color:#A1A8B2;
    cursor: pointer;
  }
  .current-route {
    color: #00af84;
  }
}
</style>